/**
 * [state 状态]
 * userData 用户数据
 * 
 * [actions 事件派发]
 * SET_USERDATA 改变状态中的用户数据]
 * 
 * [mutations 状态变更]
 */
const storeData = {
  managerStorage: JSON.parse(window.localStorage.getItem('managerStorage')),
  fManagerStorage: JSON.parse(window.localStorage.getItem('fManagerStorage')),
  sManagerStorage: JSON.parse(window.localStorage.getItem('sManagerStorage')),
}

export default {
  state: {
    managerStorage: storeData.managerStorage ? storeData.managerStorage : [],
    fManagerStorage: storeData.fManagerStorage ? storeData.fManagerStorage : [],
    sManagerStorage: storeData.sManagerStorage ? storeData.sManagerStorage : [],
  },
  mutations: {
    set_managerStorage(state, val) {
      state.managerStorage = val
      let _f = [],
        _s = []
      for (let i = 0; i < state.managerStorage.length; i++) {
        let _item = state.managerStorage[i]
        switch (_item.level) {
          case "1":
            _f.push(_item)
            break;
          case "2":
            _s.push(_item)
            break;
        }
      }
      state.fManagerStorage = _f
      state.sManagerStorage = _s

      window.localStorage.setItem('managerStorage', JSON.stringify(val))
      window.localStorage.setItem('fManagerStorage', JSON.stringify(_f))
      window.localStorage.setItem('sManagerStorage', JSON.stringify(_s))
    },
  },
  actions: {}
}


// WEBPACK FOOTER //
// ./src/store/storage.js